export const PAGE_SEO_CONTENT = {
  home: {
    title: "Discover Clubs, Events and Artists Near You",
    paragraphs: [
      "Looking for the best clubs, live events, DJs, lounges, and nightlife near you? Azzir helps you discover weekend parties, live music, rooftop lounges, Bollywood nights, EDM festivals, and more—all in one place. Explore trending clubs, featured artists, and upcoming events based on your location. Whether you're planning a night out or searching for things to do this weekend, Azzir makes it easy to find unforgettable experiences. Your destination for clubs, events, artists, lounges, and nightlife starts with Azzir.",
    ],
  },
  clubs: {
    title: "Discover Clubs Near You",
    paragraphs: [
      "Looking for the best clubs, nightlife, and live music experiences? Azzir helps you discover trending nightclubs, rooftop clubs, VIP lounges, DJ nights, Bollywood clubs, EDM parties, and exclusive nightlife venues near you. Browse top-rated clubs, explore upcoming club events, and find the perfect destination for your next night out.",
      "Whether you're planning a weekend party or searching for the hottest clubs in your city, Azzir makes it easy to discover exciting nightlife experiences and unforgettable entertainment.",
      "Explore the best clubs, book your next night out, and experience the city's nightlife with Azzir.",
    ],
  },
  events: {
    title: "Discover Nightlife Events Near You",
    paragraphs: [
      "Looking for the best events near you? Azzir helps you discover exciting live events, club events, music festivals, DJ nights, Bollywood parties, birthday parties events, and more. Browse upcoming events based on your location, favourite music genres, and nightlife preferences to find your next unforgettable experience.",
      "Whether you're planning a weekend outing or searching for things to do this weekend, Azzir makes it easy to explore trending events, discover talented artists, and stay updated with the latest entertainment happening in your city. Explore upcoming events, book your favourite experiences, and enjoy unforgettable nightlife with Azzir.",
    ],
  },
  artists: {
    title: "Discover DJs, Singers and Performing Artists",
    paragraphs: [
      "Explore DJs, singers and performing artists listed on Azzir. Discover their genres, profiles, associated venues and performances so you can follow favourites and plan your next night out.",
    ],
  },
  houseParties: {
    title: "Discover House Parties Near You",
    paragraphs: [
      "Hosting a house party? Azzir helps you arrange food, sheesha, beverages, and a singer or DJ for your celebration. Share your party details and our team will get in touch to plan the night.",
    ],
  },
  contact: {
    title: "Contact Azzir",
    paragraphs: [
      "Have questions about clubs, events, artists, lounges, or nightlife experiences? Our team is here to help. Whether you need support, want to list your event, partner with Azzir, or have a business enquiry, we'd love to hear from you.",
      "Contact Azzir today and discover how we can help you connect with the best events and entertainment near you.",
    ],
  },
};
